import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const ShortCoursesHeader = () => {
  return (
    <CourseHeader
      title=""
      highlight="Short Courses"
      subtitle="Learn. Grow. Succeed."
      backgroundImage="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=2072&q=80"
    />
  );
};

export default ShortCoursesHeader;
